import React, { Children, cloneElement, isValidElement } from 'react';
import cn from 'classnames';
import styles from './Tabs.module.scss';

const Tabs = ({
  centered = false,
  className,
  onChange,
  orientation = 'horizontal',
  children: childrenProp,
  value,
}) => {
  let childIndex = 0;

  const children = Children.map(childrenProp, (child) => {
    if (!isValidElement(child)) {
      return null;
    }

    const childValue =
      child.props.value === undefined ? childIndex : child.props.value;

    const selected = Array.isArray(value)
      ? value.includes(childValue)
      : childValue === value;

    childIndex += 1;

    return (
      <li>
        {cloneElement(child, {
          selected,
          onChange,
          value: childValue,
        })}
      </li>
    );
  });

  return (
    <ul
      className={cn(styles.root, className, {
        [styles.centered]: centered,
        [styles.vertical]: orientation === 'vertical',
      })}
    >
      {children}
    </ul>
  );
};

export default Tabs;
